module.exports = __webpack_public_path__ + "img/logout.79e432e2.svg";